import ErrorHandler from './ErrorHandler';

export const callWithErrorHandler = (func: () => void) => {
  try {
    func();
  } catch (e) {
    ErrorHandler.sendError(e);
  }
};
